/**
 * Delay a page until after $nextTick and an optional delay.
 *
 * @param {number} delay the miliseconds of additional delay.
 */
export default (delay = 0) => {
  return {
    data: () => ({
      pageReady: false,
      delay,
    }),

    async mounted() {
      await this.$nextTick()

      setTimeout(() => {
        this.pageReady = true
      }, this.delay)
    },
  }
}
